// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoLinksSearchStyles } from "@conklin/Overrides/Widgets/Header/LogoLinksSearch";
import { DivWrapper } from "@conklin/XDL/constants";
import { ellipsis, xScreen } from "@conklin/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 16px;
        width: 100%;

        ${({ isCheckout }: any) => {
            if (isCheckout) {
                return css`
                    ${xScreen("lte", "md")} {
                        > div:first-of-type {
                            order: 1;
                        }
                        > ${StyledButton} {
                            order: 2;
                        }
                        > ${TypographyStyle}, > div:last-of-type {
                            width: 100%;
                            > ${TypographyStyle} {
                                ${ellipsis(1)};
                            }
                        }
                    }
                `;
            }
        }}
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        padding: 0;
        flex: 1;
    `,
};

logoLinksSearchStyles.actionsWrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-left: auto;
        column-gap: 12px;

        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }

        ${DivWrapper} {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            column-gap: 12px;

            ${xScreen("lte", "md")} {
                column-gap: 20px;
            }
        }
    `,
};

logoLinksSearchStyles.mobileSearch = {
    css: css`
        display: inline-block;
        line-height: 1;
    `,
};
